export const VUEX_APPBAR_SHOW = 'VUEX_APPBAR_SHOW'
export const VUEX_APPBAR_HIDE = 'VUEX_APPBAR_HIDE'
